// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2a4a3b52","239":"d1a26b59","732":"533268b5"}[chunkId] + ".chunk.js";
};